{
  "title": "Add a Child Profile",
  "subtitle": "Create a safe space for your child to learn.",
  "form": {
    "labels": {
      "nickname": "Nickname",
      "grade": "Grade Level",
      "pin": "Secret PIN (Optional)"
    },
    "placeholders": {
      "nickname": "e.g. Leo",
      "pin": "4-digit code"
    },
    "hints": {
      "nickname": "We recommend using a nickname, not their full legal name.",
      "pin": "Used for child login."
    },
    "grade": "Grade {grade}",
    "actions": {
      "saving": "Saving...",
      "save": "Save Profile"
    }
  },
  "errors": {
    "create": "Failed to add child profile"
  }
}
